import { FormField } from '../FormField';

interface AuthFieldProps {
  title: string;
  required?: boolean;
  children: React.ReactNode;
}

export const AuthField = ({ title, required, children }: AuthFieldProps) => {
  return (
    <FormField
      text={title}
      required={required}
      containerClassName="flex-1 flex-col gap-1 max-md:flex-initial max-md:w-full"
      textOuterWrapperClassName="w-auto"
      textWrapperClassName="text-[0.8125rem] font-[500]"
      textClassName="text-gray-900"
    >
      {children}
    </FormField>
  );
};
